import React from 'react';
type LogoProps = {
  variant?: 'light' | 'dark';
  size?: 'sm' | 'md';
};
const LOGO_SRC = 'https://cdn.magicpatterns.com/uploads/akRqd3bcrkbwmbcMz8p9JR/adroi-logo-1dash350x180.jpg';
export function Logo({
  variant = 'light',
  size = 'md'
}: LogoProps) {
  const height = size === 'sm' ? 'h-16 lg:h-20' : 'h-20 lg:h-24';
  const image = <img src={LOGO_SRC} alt="AdROI Marketing & Conversions" width={350} height={180} className={`${height} w-auto object-contain`} data-id="element-597" data-mp="3v97cb2li08sj" />;

  // The logo file has a white background, so on dark surfaces it sits on a white plate.
  if (variant === 'dark') {
    return <span className="inline-flex rounded-lg bg-white px-3 py-2" data-id="element-598" data-mp="drmstqo0h4lb">{image}</span>;
  }
  return image;
}